<div class="warehouse-dashboard-v2">

<h3 class="dashboard-title"> Dashboard</h3>

<!-- Filters Row with Date Range Display inside -->
<app-dashboard-filters
  [dateFilter]="dateFilter"
  [customFromDate]="customFromDate"
  [customToDate]="customToDate"
  [storeFilter]="storeFilter"
  [isLoading]="isLoading"
  [isLoadingFilters]="isLoadingFilters"
  [isLoadingStores]="isLoadingStores"
  [dateFilters]="dateFilters"
  [stores]="stores"
  [resolvedDateRange]="resolvedDateRange"
  (dateFilterChange)="dateFilter = $event"
  (customFromDateChange)="onCustomFromDateChange($event)"
  (customToDateChange)="onCustomToDateChange($event)"
  (storeFilterChange)="storeFilter = $event"
  (onCustomSearch)="onCustomSearch()"
  (onDateFilterChange)="onDateFilterChange()"
  (onStoreFilterChange)="onStoreFilterChange()"
></app-dashboard-filters>

<!-- Loading Indicator -->
<div *ngIf="isLoading" class="loading-indicator">
  <div class="loading-spinner"></div>
  <span>Loading metrics...</span>
</div>

<!-- Custom Date Range Incomplete Message -->
<div *ngIf="isCustomDateRangeIncomplete" class="custom-date-message">
  <div class="message-icon">📅</div>
  <span>Please select both From and To dates to view dashboard data</span>
</div>

<!-- Metric Summary Row -->
<app-dashboard-metrics [metrics]="metrics" [accentColors]="accentColors" [isLoading]="isLoading" (metricClick)="onMetricWidgetClick($event)"></app-dashboard-metrics>

<!-- Chart widgets -->
<div class="dashboard-charts-grid">
  <div class="dashboard-chart-cell">
    <app-consumption-trend-chart 
      [isLoadingConsumptionTrend]="isLoadingConsumptionTrend"
      [consumptionTrendData]="consumptionTrendData">
    </app-consumption-trend-chart>
  </div>
  <div class="dashboard-chart-cell">
    <app-top-consumed-products-chart 
      [isLoadingTopConsumedProducts]="isLoadingTopConsumedProducts"
      [topConsumedProductsData]="topConsumedProductsData">
    </app-top-consumed-products-chart>
  </div>
  <div class="dashboard-chart-cell">
    <app-most-consumed-product-type-chart 
      [isLoadingMostConsumedProductType]="isLoadingMostConsumedProductType"
      [mostConsumedProductTypeData]="mostConsumedProductTypeData"
      [mostConsumedProductTypeCategory]="mostConsumedProductTypeCategory"
      (mostConsumedProductTypeCategoryChange)="mostConsumedProductTypeCategory = $event"
      (toggle)="loadMostConsumedProductType()">
    </app-most-consumed-product-type-chart>
  </div>
  <div class="dashboard-chart-cell">
    <app-low-stock-chart 
      [isLoadingLowStock]="isLoadingLowStock"
      [lowStockData]="lowStockData">
    </app-low-stock-chart>
  </div>
  <div class="dashboard-chart-cell">
    <app-expired-product-summary-chart 
      [isLoadingExpiredSummary]="isLoadingExpiredSummary"
      [expiredSummaryData]="expiredSummaryData">
    </app-expired-product-summary-chart>
  </div>
  <div class="dashboard-chart-cell">
    <app-expiring-soon-chart 
      [isLoadingAboutToExpiry]="isLoadingAboutToExpiry"
      [aboutToExpiryData]="aboutToExpiryData">
    </app-expiring-soon-chart>
  </div>
</div>
</div>
